
export default function WhyChooseUsSection() {
  const features = [
    {
      icon: 'ri-award-line',
      title: '20+ Years of Clinical Experience',
      description: 'Decades of expertise in family medicine and integrative wellness treatments.'
    },
    {
      icon: 'ri-stethoscope-line',
      title: 'Licensed Medical Provider',
      description: 'All treatments supervised by certified medical professionals for your safety.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Personalized Health Plans',
      description: 'Customized treatment protocols tailored to your unique health needs and goals.'
    },
    {
      icon: 'ri-microscope-line',
      title: 'Cutting-Edge Treatments',
      description: 'Latest advances in peptide therapy, IV treatments, and regenerative medicine.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safe, Effective, Science-Backed',
      description: 'Evidence-based treatments with proven safety profiles and clinical results.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Fast Results with Long-Term Benefits',
      description: 'Experience rapid improvements while building lasting health transformations.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-black mb-4">
            Why Choose <span className="text-[#8A4F8A]">Renew Integrative Wellness</span>
          </h2>
          <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
            Experience the difference of personalized, science-backed wellness care with our expert medical team.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-lg hover:bg-gradient-to-b hover:from-[#F0F0F0] hover:to-white transition-colors duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-[#C8A2C8] to-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-black mb-3">{feature.title}</h3>
              <p className="text-[#B0B0B0]">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#8A4F8A] to-[#C8A2C8] rounded-2xl p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-4">Ready to Transform Your Health?</h3>
          <p className="text-lg mb-6 opacity-90">
            Join thousands of patients who have experienced life-changing results with our integrative wellness approach.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-[#8A4F8A] px-8 py-3 rounded-lg font-semibold hover:bg-[#F0F0F0] transition-colors whitespace-nowrap">
              <i className="ri-calendar-line mr-2"></i>
              Book Your Consultation
            </button>
            <a 
              href="tel:202-269-6600" 
              className="bg-black hover:bg-[#333333] text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call (202) 269-6600
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
